import { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import MetricsTileComponent from '../../../components/ui/metrics-tile';
import { Metrics } from '../../../resources/metrics/metrics-model';
import { formatMetricsExecutionTime } from '../../../utils/date-utils';

type Props = {
  metrics?: Metrics[] | null;
};

export default function DashboardMetricsComponent({ metrics }: Props) {
  const formattedExecutionTime = useMemo(() => formatMetricsExecutionTime(metrics), [metrics]);

  const formattedErrors = useMemo(() => {
    let errors: string | undefined;

    if (metrics) {
      const totalErrors = metrics.reduce((acc, curr) => acc + curr.numberOfErrors, 0) ?? 0;
      const totalExecutions = metrics.reduce((acc, curr) => acc + curr.numberOfExecutions, 0) ?? 1;
      const errorPercentage = totalExecutions > 0 ? (totalErrors / totalExecutions) * 100 : 0;

      return `${metrics
        ?.reduce((acc, curr) => acc + curr.numberOfErrors, 0)
        ?.toLocaleString()} / ${errorPercentage.toFixed()}%`;
    }

    return errors;
  }, [metrics]);

  const overallTransactionsPerSecond = useMemo(() => {
    if (metrics) {
      const totalExecutions = metrics.reduce((acc, curr) => acc + curr.numberOfExecutions, 0);
      const totalExecutionTimeSeconds = metrics.reduce((acc, curr) => acc + curr.totalExecutionTime, 0) / 1000;

      return totalExecutions / totalExecutionTimeSeconds;
    }
  }, [metrics]);

  return (
    <Row>
      <Col>
        <MetricsTileComponent
          id="number-of-executions"
          title="Number of executions"
          formattedData={metrics?.reduce((acc, curr) => acc + curr.numberOfExecutions, 0)?.toLocaleString()}
        />
      </Col>
      <Col>
        <MetricsTileComponent
          id="transactions-per-second"
          title="Tps"
          formattedData={overallTransactionsPerSecond?.toLocaleString()}
        />
      </Col>
      <Col>
        <MetricsTileComponent id="execution-time" title="Execution time" formattedData={formattedExecutionTime} />
      </Col>
      <Col>
        <MetricsTileComponent
          id="number-of-errors"
          title="Number of Errors"
          formattedData={formattedErrors}
          variant="warning"
        />
      </Col>
    </Row>
  );
}
